// Import all about page hero images
import heroTransform01 from '../assets/images/about/hero-transform-01.png';
import heroTransform02 from '../assets/images/about/hero-transform-02.png';
import heroTransform03 from '../assets/images/about/hero-transform-03.png';
import heroTransform04 from '../assets/images/about/hero-transform-04.png';
import heroTransform05 from '../assets/images/about/hero-transform-05.png';

export const ABOUT_HERO_IMAGES = [
  heroTransform01,
  heroTransform02,
  heroTransform03,
  heroTransform04,
  heroTransform05,
];
